import { Injectable, inject } from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Blog } from '@models/blog.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { urlDecode } from '@utils/urlHelpers';

type BlogResponse = {
  blogList: Blog[];
  blogCats: { catId: number; catName: string; img: string }[];
};

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  protected readonly env = inject(EnvToken);

  newBaseHref = `${this.env.dashboardBaseRef}api/${this.env.apiPrefix}blogs`;

  constructor(private http: HttpClient) {}

  fetchAllBlogPost(): Observable<BlogResponse> {
    const url = `${this.newBaseHref}/all`;
    return this.http.get<any>(url).pipe(
      map((response: any) => ({
        blogList: response.blogList.map((blog: any) => new Blog(blog)),
        blogCats: response.blogCats
      }))
    );
  }

  fetchBlogById(
    slug: string,
    mainCat?: string,
    subCat?: string,
  ): Observable<Blog> {
    const url = `${this.newBaseHref}/${slug}`;
    let params = new HttpParams();
    if (mainCat) {
      const decodedMainCat = urlDecode(mainCat.toLowerCase().trim());
      params = params.append('mainCat', decodedMainCat);
    }
    if (subCat) {
      const decodedSubcat = urlDecode(subCat?.toLowerCase().trim());
      params = params.append('subCat', decodedSubcat);
    }
    return this.http.get<any>(url, { params }).pipe(
      map((blog: any) => new Blog(blog))
    );
  }

  fetchRelatedPosts(relatedBlogs: {
    currentBlogId: number;
    asCat?: number;
  }): Observable<Blog[]> {
    const url = `${this.newBaseHref}/related`;
    return this.http.post<any[]>(url, relatedBlogs).pipe(
      map((blogs: any[]) => blogs.map(blog => new Blog(blog)))
    );
  }
}
